import React, { useEffect, useState } from 'react';
import { Checkbox, Input, Modal, Typography } from 'antd';
import { noteIsValid } from './assistantMembership';

const { Paragraph, Text } = Typography;

function copyFor(mode, specialistName, targetName) {
  if (mode === 'make-router') {
    return {
      title: `Make ${targetName} a router?`,
      body: `${targetName} will send each question to the assistants under it, starting with ${specialistName}, instead of answering those questions itself.`,
      okText: 'Make router',
    };
  }
  if (mode === 'already') {
    return {
      title: `${specialistName} is already under ${targetName}`,
      body: `${specialistName} is already under ${targetName}.`,
      okText: 'Close',
    };
  }
  return {
    title: `Add ${specialistName} under ${targetName}`,
    body: `${targetName} will send matching questions to ${specialistName}. ${specialistName} stays the same assistant and can still be used by other routers.`,
    okText: 'Add',
  };
}

export default function AssistantGroupDialog({
  open,
  mode,
  specialistName,
  targetName,
  others,
  confirmLoading,
  error,
  onCancel,
  onConfirm,
}) {
  const [hint, setHint] = useState('');
  const [move, setMove] = useState(false);
  const copy = copyFor(mode, specialistName, targetName);
  const already = mode === 'already';
  const otherNames = (others || []).map((item) => item.router_name).filter(Boolean);

  useEffect(() => {
    if (open) {
      setHint('');
      setMove(false);
    }
  }, [open, mode, specialistName, targetName]);

  return (
    <Modal
      open={open}
      closable={!already}
      title={copy.title}
      okText={copy.okText}
      cancelText="Cancel"
      confirmLoading={confirmLoading}
      okButtonProps={{ disabled: already ? false : !noteIsValid(hint) }}
      cancelButtonProps={{ style: already ? { display: 'none' } : undefined }}
      onCancel={onCancel}
      onOk={() => {
        if (already) onCancel();
        else onConfirm({ hint: hint.trim(), move });
      }}
      destroyOnClose
    >
      <Paragraph>{copy.body}</Paragraph>
      {!already && (
        <label>
          <Text>When to use</Text>
          <Input
            aria-label="When to use"
            value={hint}
            maxLength={500}
            onChange={(event) => setHint(event.target.value)}
          />
        </label>
      )}
      {!already && otherNames.length > 0 && (
        <Checkbox checked={move} onChange={(event) => setMove(event.target.checked)}>
          Move here instead
        </Checkbox>
      )}
      {!already && otherNames.length > 0 && (
        <Paragraph type="secondary">Leave {otherNames.join(', ')}.</Paragraph>
      )}
      {error ? <Paragraph type="danger">{error}</Paragraph> : null}
    </Modal>
  );
}
